import { render, staticRenderFns } from "./room.vue?vue&type=template&id=c7a651c0&scoped=true"
import script from "./room.vue?vue&type=script&lang=js"
export * from "./room.vue?vue&type=script&lang=js"
import style0 from "./room.vue?vue&type=style&index=0&id=c7a651c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a651c0",
  null
  
)

export default component.exports